import { useEffect, useRef, useState } from "react";
import { Keyboard } from "lucide-react";

interface Props {
  onSend: (text: string) => void;
  disabled?: boolean;
}

export function TextSender({ onSend, disabled }: Props) {
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState("");
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (open) inputRef.current?.focus();
  }, [open]);

  if (!open) {
    return (
      <button
        type="button"
        onClick={() => setOpen(true)}
        disabled={disabled}
        title="Send text"
        className="inline-flex items-center justify-center w-8 h-8 rounded-md border border-surface-700 text-surface-200 hover:bg-surface-800 disabled:opacity-50"
      >
        <Keyboard className="w-4 h-4" />
      </button>
    );
  }

  const close = () => {
    setValue("");
    setOpen(false);
  };

  return (
    <input
      ref={inputRef}
      type="text"
      placeholder="Type, Enter to send"
      value={value}
      disabled={disabled}
      onChange={(e) => setValue(e.target.value)}
      onBlur={close}
      onKeyDown={(e) => {
        if (e.key === "Enter" && value) {
          e.preventDefault();
          onSend(value);
          setValue("");
        } else if (e.key === "Escape") {
          e.preventDefault();
          close();
        }
      }}
      className="h-8 w-48 bg-surface-800 border border-surface-600 rounded-md px-2 text-xs placeholder:text-surface-600 focus:outline-none focus:border-accent-cyan"
    />
  );
}
